/**
 * Constants here need to define different URLs based on the context in which the application is running (there's a few):
 *  - Running locally, starting the Web.UI project directly
 *  - Running locally for UI dev, serving the SPA only
 *  - Running on prod
 *
 * TODO => use .env / environment variables
 *
 * Running locally via Web.UI:
 *  - assumes the Api.Service project is also running, and available at localhost:50372, for all package data
 *  - ignores the apiBaseUrl value, unless data-is-prod is flipped to true, in which case will get data from remote
 *  - all requests for images/icons are remote
 *  - requires building the SPA, and rebuilding for changes to render
 *
 * Running locally via SPA:
 *  - all requests for images/icons are remote
 *  - package data comes from dev.api.marketplace.umbraco.com
 *
 * AKA running SPA is entirely decoupled, running Web.UI requires Api.Services project be running
 */

const apiUrl = document.body.dataset.apiBaseUrl ?? 'https://dev.api.marketplace.umbraco.com/';
const functionsUrl = document.body.dataset.functionsBaseUrl ?? 'https://dev.functions.marketplace.umbraco.com/';
const isProd = document.body.dataset.isProd === 'true';
const isLocal = document.body.dataset.isLocal === 'true';

/**
 * apiUrl value will only exist if serving Web.UI (optionally for local, always for prod)
 * @returns
 */
export function apiBaseUrl() {
  return `${apiUrl}api/v1.0/`;
}

/**
 * Will use apiUrl value for prod, and only for Web.UI. SPA will use localhost
 */
export const validationApiBaseUrl = apiUrl;

/**
 * Images always from dev when local - either SPA or Web.UI
 */
export const imagesBaseUrl =
  isLocal || !isProd
    ? 'https://dev.marketplace.umbraco.com/'
    : '/';

// POST only => body is { "PackageId": "value" }
export const packageSyncUrl = `${functionsUrl}/api/InitiateSinglePackageSyncFunction`;

// umbraco blue
export const fallbackColor = '#3544b1';
